import React, { useCallback } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  Toolbar,
  SaveButton,
  required,
  minValue,
  useNotify,
  useRedirect,
  useRefresh,
} from 'react-admin';
import { useExchangeRate } from '../../context/ExchangeRateContext';
import { CreateActions } from '../utilities/CreateView';

const TradeRevAutoProxyCreateToolbar = ({ handlePostSave, ...props }) => (
  <Toolbar {...props}>
    <SaveButton
      label="Save and Show List"
      redirect="list"
      submitOnEnter={true}
    />
    <SaveButton
      label="Save and Add"
      redirect={false}
      onSuccess={handlePostSave}
      submitOnEnter={false}
      variant="text"
    />
  </Toolbar>
);

const TradeRevAutoProxyCreate = props => {
  const { exchangeRate, setExchangeRate } = useExchangeRate();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  const handlePostSave = useCallback(() => {
    notify('Saved successfully', { type: 'info' });
    refresh(); // reset the form
  }, [notify, refresh]);

  return (
    <Create {...props} actions={<CreateActions />}>
      <SimpleForm
        resetOptions={{ keepDirtyValues: false }}
        toolbar={<TradeRevAutoProxyCreateToolbar handlePostSave={handlePostSave} />}
        onSubmit={() => {}} // optional, if needed
      >
        <TextInput label="Trade ID" source="trade_id" validate={[required()]} />
        <NumberInput label="Rate" source="rate" step={0.01} validate={[required(), minValue(0)]} defaultValue={exchangeRate} onChange={e => setExchangeRate(Number(e.target.value))}        />
        <NumberInput label="US Selling Price" source="us" step={1} validate={[required(), minValue(0)]} />
        <NumberInput label="Proxy" source="proxy" step={1} validate={[required(), minValue(0)]} />
        <TextInput label="Proxy Suggestion" source="proxy_suggestion" />
      </SimpleForm>
    </Create>
  );
};

export default TradeRevAutoProxyCreate;
